import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=0914d4be&scoped=true"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=0914d4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914d4be",
  null
  
)

export default component.exports